import Card from 'components/Layout/Card'
import DetailItem from 'components/Layout/DetailItem'
import Loader from 'components/Layout/Loader'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { fetchAbstractAndAuthorDetails } from 'store/slices'
import { eventAbstarctPath, icons, paymentAbstractPath } from 'utils/constants'
import { getDataFromLocalStorage, getUserType, handleFileDownload } from 'utils/helpers'

const AuthorCoauthorsDetails = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams();
  const { requestId } = params;
  const memberType = getUserType()

  const [isExpanded, setIsExpanded] = useState(false)
  const [abstractData, setAbstractData] = useState({})
  const toggleReadMore = () => setIsExpanded(!isExpanded)
  const [isLoading, setIsLoading] = useState(true);


  const getAbstractAndAuthorDetails = async () => {

    const payload = {
      request_id: requestId,
      display_co_author_details: true
    }
    setIsLoading(true);
    const response = await dispatch(fetchAbstractAndAuthorDetails(payload));
    if (response?.data) {
      setAbstractData(response?.data)
    }
    setIsLoading(false);
  };


  useEffect(() => {
    if (['0', '1', '6', '7'].includes(getDataFromLocalStorage('user_type'))) {
      getAbstractAndAuthorDetails()
    } else {
      navigate('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestId]);

  const {
    paper_title,
    paper_abstract,
    abstract_path,
    abstractPathFileName,
    payment_proof,
    paper_keywords,
    presentation_type,
    submission_type,
    co_authors,
    author_name,
    authors_email,
    authors
  } = abstractData

  const abstractWords = paper_abstract?.replace(/<\/?p>/g, "").split(" ")
  const maxWords = 100

  return (
    <>
      {isLoading ? <Card className="cp-24">
        <Loader size="md" />
      </Card> :
        <>
          {/* Abstract Details */}
          <Card className="cp-24">
            <div>
              <div className='d-flex '>
                <div className="d-flex" onClick={() => navigate(-1)}>
                  <img src={icons.leftArrow} alt="back" className="h-21 me-2 pointer" />
                </div>

                <div className="text-14-500-18 color-text-blue cmb-20">
                  Abstract Details :
                </div>
              </div>

              <div className="text-14-400-18 color-1717">Paper Title</div>
              <div className="text-14-300-24 color-black-olive cpt-10">
                {paper_title || '-'}
              </div>

              {abstractWords && (
                <>
                  <div className="text-14-400-18 color-1717 cmt-10">Abstract</div>
                  <div className="text-14-300-24 color-black-olive">
                    {isExpanded ? (
                      <span dangerouslySetInnerHTML={{ __html: paper_abstract }} />
                    ) : (
                      <>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: abstractWords.slice(0, maxWords).join(" "),
                          }}
                        />
                        {abstractWords.length > maxWords && (
                          <>
                            {"... "}
                            <span
                              onClick={toggleReadMore}
                              className="text-14-500-23 color-new-car pointer"
                            >
                              Read More
                            </span>
                          </>
                        )}
                      </>
                    )}
                    {isExpanded && (
                      <span
                        onClick={toggleReadMore}
                        className="text-14-500-23 color-new-car pointer"
                      >
                        Read Less
                      </span>
                    )}
                  </div>
                </>
              )}

              <div className="cmt-10">
                <div className="row">
                  <div className="col-md-3 col-sm-6 col-12">
                    <DetailItem
                      label="Paper Documents"
                      type="url"
                      fileName={abstract_path}
                      handleFileDownload={handleFileDownload}
                      value={abstractPathFileName}
                      filePath={eventAbstarctPath}
                    />
                  </div>
                  <div className="col-md-3 col-sm-6 col-12">
                    <DetailItem
                      label="Payment Proof"
                      type="url"
                      fileName={payment_proof}
                      handleFileDownload={handleFileDownload}
                      value={payment_proof}
                      filePath={paymentAbstractPath}
                    />
                  </div>
                  <div className="col-md-6 col-sm-6 col-12">
                    <DetailItem label="Keywords" value={paper_keywords} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3 col-sm-6 col-12">
                    <DetailItem label="Presentation Type" value={presentation_type} />
                  </div>
                  <div className="col-md-3 col-sm-6 col-12">
                    <DetailItem label="Submission Type" value={submission_type} />
                  </div>
                </div>
              </div>
            </div>
          </Card>

          {/* Author & Coauthors */}
          <Card className="cp-24 cmt-10 cmb-10">
            <div className="text-14-500-18 color-text-blue cmb-20">
              Author & Coauthors Details :
            </div>

            <div className="row">
              <div className="col-md-3 col-sm-6 col-12">
                <DetailItem label="Author" value={author_name} />
              </div>
              <div className="col-md-3 col-sm-6 col-12">
                <DetailItem label="Email Id" value={authors_email} />
              </div>
              <div
                className="col-md-6 col-sm-6 col-12 d-flex align-items-center pointer"
                onClick={() => navigate(`/${memberType}/author-details/${authors}`)}
              >
                <p className="text-14-400-18 color-7cff mt-md-4 mt-0 d-flex align-items-center">
                  <img src={icons?.blueEyeIcon} className="me-2" alt="View Icon" />
                  View Profile
                </p>
              </div>
            </div>

            {co_authors?.map((coAuthor, index) => (
              <div className="row" key={coAuthor.id}>
                <div className="col-md-3 col-sm-6 col-12">
                  <DetailItem label={`Co-Author ${index + 1}`} value={coAuthor?.name || '-'} />
                </div>
                <div className="col-md-3 col-sm-6 col-12">
                  <DetailItem label="Email Id" value={coAuthor?.email || '-'} />
                </div>
                {coAuthor?.id &&
                  <div
                    className="col-md-6 col-sm-6 col-12 d-flex align-items-center pointer"
                    onClick={() => navigate(`/${memberType}/author-details/${coAuthor?.id}`)}
                  >
                    <p className="text-14-400-18 color-7cff mt-md-4 mt-0 d-flex align-items-center">
                      <img src={icons?.blueEyeIcon} className="me-2" alt="View Icon" />
                      View Profile
                    </p>
                  </div>}
              </div>
            ))}
          </Card>
        </>}
    </>
  )
}

export default AuthorCoauthorsDetails
